import React from 'react';
import { FaCertificate } from 'react-icons/fa';
import DepartamentoPedidosPage from './DepartamentoPedidosPage';

const CertidoesPage = () => (
  <DepartamentoPedidosPage
    departamentoId="certidoes"
    titulo="Certidões"
    Icon={FaCertificate}
  />
);

export default CertidoesPage;
